// Returns display name for agent or builder
// If user is a Builder, returns "Builder Company Name - Agent Name"
// Otherwise, returns "Agent Name"
export function getDisplayName(user) {
  if (!user) return "";
  if (user.class_type === "Builder" && user.builder_company_name) {
    return `${user.builder_company_name} - ${user.legal_first_name || ""} ${
      user.legal_last_name || ""
    }`.trim();
  }
  return `${user.legal_first_name || ""} ${user.legal_last_name || ""}`.trim();
}
